var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 13 13",
    style: {
      width: 24
    },
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1515_18420)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.63477 2.23575C8.76609 2.10442 8.92199 2.00025 9.09357 1.92918C9.26515 1.85811 9.44905 1.82153 9.63477 1.82153C9.82048 1.82153 10.0044 1.85811 10.176 1.92918C10.3475 2.00025 10.5034 2.10442 10.6348 2.23575C10.7661 2.36707 10.8703 2.52297 10.9413 2.69455C11.0124 2.86613 11.049 3.05003 11.049 3.23575C11.049 3.42146 11.0124 3.60536 10.9413 3.77694C10.8703 3.94852 10.7661 4.10442 10.6348 4.23575L3.88477 10.9857L1.13477 11.7357L1.88477 8.98575L8.63477 2.23575Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1515_18420"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(0.134766 0.73584)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditBlack);
export default __webpack_public_path__ + "static/media/EditBlack.c8f85111ad1df82dd44b7b0bbaf82758.svg";
export { ForwardRef as ReactComponent };